module.exports = __webpack_public_path__ + "img/facebook.49bd157a.svg";